import _ from 'lodash';

export default class NavigatorUtils {

  /**
   * parse data, return rounteName and params to go to
   *
   * @param data data to parse
   */
  static parseRoute (data) {
    /*return {
      routeName: 'FastOrder',
    }*/

    if (!data) {
      return;
    }

    const {type, id} = data;
    if (_.isEmpty(type)) {
      return;
    }

    let routeName, path, params;
    switch (type) {
      case 'order': {
        routeName = 'Order';
        path = '/order/' + id;
        params = {
          id: id,
        };
        break;
      }
      case 'partner': {
        routeName = 'Partner';
        path = '/partner/' + id;
        params = {
          id: id,
        };
        break;
      }
      case 'agency': {
        routeName = 'Agency';
        path = '/agency/' + id;
        params = {
          id: id,
        };
        break;
      }
      case 'link': {
        routeName = 'Browser';
        params = {
          url: id,
        };
      }
      default:
        break;
    }
    if (!routeName && !path) {
      return;
    }

    return {
      routeName: routeName,
      path: path,
      params: params,
    };
  }
}



// WEBPACK FOOTER //
// ./src/utils/NavigatorUtils.js